import * as React from 'react'
import { Interval } from 'quark-web'
import { contentWidth } from '~/dims'
import * as carouselImages from './images'
import styles from './styles'

const imgDims = {
    w: 245,
    h: 150
}

class Carousel extends React.Component {
    constructor(...args) {
        super(...args)

        this.state = {
            images: Object.values(carouselImages).map(image => ({ src: image }))
        }
    }

    componentDidMount = () => setTimeout(this._rotate)

    _rotate = () => {
        this.setState(({ images }) => {
            images.push(images.shift())
            return {
                images: images
            }
        })
    }

    render = () => (
        <div
            style={{
                ...styles.container,
                ...this.props.style,
                width: contentWidth,
                height: imgDims.h
            }}
        >
            {this.state.images.slice(0, 6).map((item, i) => (
                <img
                    key={item.src}
                    src={item.src}
                    onTransitionEnd={this._rotate}
                    style={{
                        ...styles.img,
                        width: imgDims.w,
                        height: imgDims.h,
                        transition: 'margin-left 3000ms linear',
                        marginLeft: i === 0 ? -imgDims.w : 0
                    }}
                />
            ))}
        </div>
    )
}

export default Carousel



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js